<ng-template #chatGptContentForm role="document" let-modal>

  <app-modal-comp-header
    [headerActionIconClass]="pinnedDocked ? 'bi-pin-angle-fill' : 'bi-pin-angle'"
    [headerActionIsActive]="pinnedDocked"
    [headerActionTitle]="pinnedDocked ? 'Unpin assistant' : 'Pin assistant'"
    [microsoftIconClass]="'microsoft-icon-sm'"
    [showHeaderActionIcon]="true"
    [showMicrosoftIcon]="chatGptShowConnectionTypeIcon && chatGptUseAzureOpenAi"
    [showOpenAiIcon]="chatGptShowConnectionTypeIcon && !chatGptUseAzureOpenAi"
    [title]="chatGptAliasShort"
    (cancelButtonOnClick)="chatGptFormCancel()"
    (headerActionButtonOnClick)="togglePinnedDocked()"
    (headerMouseDown)="onAssistantHeaderMouseDown($event)"
  ></app-modal-comp-header>
  
  <div class="modal-body">
    <form
      autocomplete="off"
      class="tablelist-form"
      enctype="multipart/form-data"
      [formGroup]="chatGptForm"
      (keydown)="onModalKeyDown($event)"
      (ngSubmit)="chatGptFormSubmit()"
    >
      
      <div class="row">
        <div class="col-12">
          <div class="mt-0 mb-0">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}} text-center" role="alert" style="margin-top: -30px;">
              <strong><span [innerHtml]="progressInformation" ></span></strong>
            </div>
            @if (chatGptShowStageStrip) {
              <div class="assistant-stage-strip">
                @for (step of stageSteps; track step.key) {
                  <span class="assistant-stage-chip" [ngClass]="{ 'active': step.active, 'completed': step.completed }">{{ step.label }}</span>
                }
              </div>
            }
            @if (onboardingVisible) {
              <div class="assistant-onboarding">
                <div class="assistant-onboarding-body">
                  <div class="assistant-onboarding-title">Tips</div>
                  <div class="assistant-onboarding-text" [innerHTML]="onboardingSteps[onboardingStepIndex]"></div>
                  <div class="assistant-onboarding-hint">Quotes & [ ] not required</div>
                </div>
                <div class="assistant-onboarding-actions">
                  <button type="button" class="btn btn-sm btn-primary" (click)="previousOnboardingStep()" [disabled]="onboardingStepIndex === 0">Previous</button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="nextOnboardingStep()" [disabled]="onboardingStepIndex >= onboardingSteps.length - 1">Next</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="dismissOnboarding()">Close</button>
                </div>
              </div>
            }
            <div class="assistant-top-controls">
              <label class="assistant-inline-check" title="Keep the Assistant open after each action">
                <input type="checkbox" [checked]="copilotMode" (change)="onCopilotModeChanged($any($event.target).checked)">
                Keep Assistant open
              </label>
              <label class="assistant-inline-check" title="Show the tips box each time the Assistant opens">
                <input type="checkbox" [checked]="onboardingVisible" (change)="onShowTipsChanged($any($event.target).checked)">
                Show tips
              </label>
              @if (chatGptShowExplainability) {
                <label class="assistant-inline-check">
                  <input type="checkbox" [checked]="explainabilityMode" (change)="onExplainabilityModeChanged($any($event.target).checked)">
                  Explainability
                </label>
              }
              @if (chatGptShowInsights) {
                <label class="assistant-inline-check">
                  <input type="checkbox" [checked]="showInsightsPanel" (change)="showInsightsPanel=$any($event.target).checked">
                  Show insights
                </label>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="assistant-stack-gap">
            <textarea
              class="form-control"
              data-lpignore="true"
              formControlName="prompt"
              id="prompt-field"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfChatGpt['prompt'].errors }"
              placeholder="Prompt..."
              rows="5"
              (input)="onPromptInput($any($event.target).value)"
              (keydown)="onPromptEnter($event)"
            >
            </textarea>
            @if (liveIntentLabel) {
              <div class="assistant-intent-preview">
                <span class="assistant-intent-arrow">&#8594;</span> {{ liveIntentLabel }}
              </div>
            }
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>

      @if (!showChatBorder && suggestedPrompts.length > 0) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-suggestions assistant-stack-gap">
              @for (suggestion of suggestedPrompts; track suggestion) {
                <button type="button" class="btn btn-sm assistant-suggestion-chip" (click)="applySuggestedPrompt(suggestion)">
                  {{ suggestion }}
                </button>
              }
            </div>
          </div>
        </div>
      }

      @if (assistantActionHistory.length>0) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-history assistant-stack-gap">
              <div class="assistant-history-title">Assistant timeline</div>
              <div class="assistant-history-list">
                @for (entry of assistantActionHistory; track entry.id) {
                  <div class="assistant-history-item">
                    <div class="assistant-history-text">
                      <span class="assistant-history-prompt">{{ entry.prompt }}</span>
                      @if (entry.actionLabel) {
                        <span class="assistant-history-action"> -> {{ entry.actionLabel }}</span>
                      }
                    </div>
                    <button type="button" class="btn btn-sm btn-link p-0" (click)="runHistoryAction(entry)">Run</button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-12">
          <div class="assistant-stack-gap assistant-response-stack">
            <div [ngClass]="{ 'animated-border p-1 rounded': showChatBorder }">
              <textarea
                class="form-control"
                data-lpignore="true"
                formControlName="response"
                id="response-field"
                [ngClass]="{
                  'assistant-response-expanded': responseSizeMode==='expanded',
                  'assistant-response-timeline': responseSizeMode==='timeline',
                  'assistant-response-timeline-dense': responseSizeMode==='timeline_dense',
                  'bg-custom' : responsePulseOn,
                  'bg-static' : !responsePulseOn,
                  'is-invalid': formSubmitted && formOfChatGpt['response'].errors
                }"
                [placeholder]="chatGptAliasFull"
                [readonly]="true"
                rows="15"
                (contextmenu)="openPopupMenuResponse($event); $event.preventDefault()"
              >
              </textarea>
            </div>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>

      @if (queuedBatchPrompts.length > 0) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-batch">
              <div class="assistant-section-title">Batch queue</div>
              <div class="assistant-batch-text">{{ queuedBatchPrompts.length }} queued prompt(s)</div>
              <div class="assistant-batch-actions">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="runNextBatchPrompt()">Run next</button>
                <button type="button" class="btn btn-sm btn-primary" (click)="runAllBatchPrompts()">Run all</button>
              </div>
            </div>
          </div>
        </div>
      }

      @if (pendingConfirmationAction) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-confirm">
              <div class="assistant-confirm-title">Confirm action</div>
              <div class="assistant-confirm-text">{{ confirmationReason }}</div>
              <div class="assistant-confirm-actions">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelPendingConfirmation()">Cancel</button>
                <button type="button" class="btn btn-sm btn-danger" (click)="confirmPendingAction()">Confirm {{ actionLabel(pendingConfirmationAction) }}</button>
              </div>
            </div>
          </div>
        </div>
      }

      @if (filteredActionCards.length > 0) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-actions assistant-actions-spacing">
              <div class="assistant-actions-header">Suggested Actions</div>
              <div class="assistant-intent-chips">
                @for (chip of intentChips; track chip) {
                  <button type="button" class="btn btn-sm assistant-intent-chip" [ngClass]="{ 'active': selectedIntentChip===chip }" (click)="selectIntentChip(chip)">
                    {{ chip }}
                  </button>
                }
              </div>
              @if (pinnedActionCards.length > 0) {
                <div class="assistant-pinned">
                  <div class="assistant-section-title">Pinned</div>
                  <div class="assistant-actions-cards">
                    @for (card of pinnedActionCards; track card.key) {
                      <div class="assistant-action-card pinned" draggable="true" (dragstart)="onPinnedDragStart($event, card)" (dragover)="onPinnedDragOver($event)" (drop)="onPinnedDrop($event, card)" [ngClass]="{ 'focused': isFocusedCard(card) }" (click)="focusCard(card)">
                        <div class="assistant-action-card-head">
                          <div class="assistant-action-card-title">{{ card.title }}</div>
                          <div class="assistant-action-card-head-right">
                            <span class="assistant-confidence" [ngClass]="card.confidence">{{ card.confidence }}</span>
                            <button type="button" class="btn btn-sm btn-link p-0 assistant-pin-btn" (click)="togglePinnedAction(card); $event.stopPropagation()">Unpin</button>
                          </div>
                        </div>
                        <div class="assistant-actions-list">
                          @for (action of card.actions; track $index) {
                            <div class="assistant-action-row">
                              <button type="button" class="btn btn-outline-primary btn-sm assistant-action-btn" (click)="executeAction(action)">
                                {{ actionLabel(action) }}
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="assistant-actions-layout">
                @if (bestActionCard) {
                  <div class="assistant-actions-best">
                    <div class="assistant-section-title">Best match</div>
                    <div class="assistant-action-card" [ngClass]="{ 'focused': isFocusedCard(bestActionCard) }" (click)="focusCard(bestActionCard)">
                      <div class="assistant-action-card-head">
                        <div class="assistant-action-card-title">{{ bestActionCard.title }}</div>
                        <div class="assistant-action-card-head-right">
                          <span class="assistant-confidence" [ngClass]="bestActionCard.confidence">{{ bestActionCard.confidence }}</span>
                          <button type="button" class="btn btn-sm btn-link p-0 assistant-pin-btn" (click)="togglePinnedAction(bestActionCard); $event.stopPropagation()">{{ bestActionCard.pinned ? 'Unpin' : 'Pin' }}</button>
                        </div>
                      </div>
                      @if (bestActionCard.previewItems.length > 0) {
                        <div class="assistant-action-card-meta">
                          @for (item of bestActionCard.previewItems; track item) {
                            <span class="assistant-meta-pill">{{ item }}</span>
                          }
                        </div>
                      }
                      <div class="assistant-actions-list">
                        @for (action of bestActionCard.actions; track $index) {
                          <div class="assistant-action-row">
                            <button type="button" class="btn btn-outline-primary btn-sm assistant-action-btn" (click)="executeAction(action)">
                              {{ actionLabel(action) }}
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                <div class="assistant-actions-other">
                  <div class="assistant-section-title">Other matches</div>
                  <div class="assistant-actions-cards">
                    @for (card of otherActionCards; track card.key) {
                      <div class="assistant-action-card" [ngClass]="{ 'focused': isFocusedCard(card) }" (click)="focusCard(card)">
                        <div class="assistant-action-card-head">
                          <div class="assistant-action-card-title">{{ card.title }}</div>
                        <div class="assistant-action-card-head-right">
                          <span class="assistant-confidence" [ngClass]="card.confidence">{{ card.confidence }}</span>
                          <button type="button" class="btn btn-sm btn-link p-0 assistant-pin-btn" (click)="togglePinnedAction(card); $event.stopPropagation()">{{ card.pinned ? 'Unpin' : 'Pin' }}</button>
                        </div>
                      </div>
                        @if (card.previewItems.length > 0) {
                          <div class="assistant-action-card-meta">
                            @for (item of card.previewItems; track item) {
                              <span class="assistant-meta-pill">{{ item }}</span>
                            }
                          </div>
                        }
                        <div class="assistant-actions-list">
                          @for (action of card.actions; track $index) {
                            <div class="assistant-action-row">
                              <button type="button" class="btn btn-outline-primary btn-sm assistant-action-btn" (click)="executeAction(action)">
                                {{ actionLabel(action) }}
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="assistant-actions-footer-row">
                <button type="button" class="btn btn-link btn-sm p-0 mt-2" (click)="clearPendingActions()">Dismiss suggestions</button>
              </div>
            </div>
          </div>
        </div>
      }

      @if (showInsightsPanel) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-insights">
              <div class="assistant-section-title">Usage insights</div>
              <div class="assistant-insights-total">Events: {{ assistantInsights.totalEvents }}</div>
              <div class="assistant-insights-list">
                @for (item of assistantInsights.topEvents; track item.eventType) {
                  <span class="assistant-meta-pill">{{ item.eventType }}: {{ item.count }}</span>
                }
              </div>
            </div>
          </div>
        </div>
      }

      @if (showAssistantDiagnostics) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-debug">
              <button type="button" class="btn btn-link btn-sm p-0" (click)="assistantDiagnosticsOpen=!assistantDiagnosticsOpen">
                {{ assistantDiagnosticsOpen ? 'Hide diagnostics' : 'Show diagnostics' }}
              </button>
              @if (assistantDiagnosticsOpen) {
                <pre class="assistant-debug-pre">{{ diagnosticsSummary() }}</pre>
              }
            </div>
          </div>
        </div>
      }

      @if (explainabilityMode && explainabilityTrace.length > 0) {
        <div class="row">
          <div class="col-12">
            <div class="assistant-explain">
              <div class="assistant-section-title">Explainability</div>
              <div class="assistant-explain-list">
                @for (step of explainabilityTrace; track step.timestamp + step.step) {
                  <div class="assistant-explain-item"><strong>{{ step.step }}</strong>: {{ step.details }}</div>
                }
              </div>
            </div>
          </div>
        </div>
      }

    </form>
  </div>

  <div class="modal-footer">
    <div class="assistant-footer-row">
      @if (chatGptPulseResponseArea) {
        <div class="form-check form-switch form-switch-md assistant-footer-breathe">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="pulseCheck-field"
            [checked]="!!chatGptForm.get('pulseCheck')?.value"
            (change)="chatGptForm.controls['pulseCheck'].setValue($any($event.target).checked); pulseClick()"
          >
          <label class="form-check-label" for="pulseCheck-field">Breathe</label>
        </div>
      }
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="chatGptFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn" (click)="chatGptFormSubmit()">Submit</button>
      </div>
    </div>
  </div>
  
  <app-page-comp-menu-bootstrap
    #popupMenuResponse
    [menuItems]="popupMenuItems_Response"
    (itemSelected)="onMenuItemSelected_Response($event)">
  ></app-page-comp-menu-bootstrap>

</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
